<template>
  <div>
    <NavBar />
    <Edit
      :item="currentSecaoRodape"
      :editorFunction="editorFunction"
      :close="closeEditor"
      :onSuccess="onEditSuccess"
    />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <div class="message" v-if="error">Erro: {{ error.message }}</div>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="35px"
              height="35px"
              viewBox="0 0 35 35"
              style="enable-background: new 0 0 35 35"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M0,0v25.366h35V0H0z M32.879,23.245H2.121V2.121h30.758V23.245z"
                  />
                  <rect y="28.283" width="9.545" height="6.717" />
                  <rect x="25.455" y="28.283" width="9.545" height="6.717" />
                  <rect x="12.727" y="28.283" width="9.546" height="6.717" />
                </g>
              </g>
            </svg>
            Seções de Rodapé
          </h1>

          <ul class="tabs"></ul>
          <div class="card">
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th>Ordem</th>
                    <th style="text-align: right">
                      <button
                        class="button button-success button-sm"
                        v-on:click="openEditor()"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          />
                        </svg>
                        Adicionar
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(secao, index) in secoesRodape" v-bind:key="index">
                    <td>{{ secao.descricao }}</td>
                    <td>{{ secao.ordem }}</td>
                    <td class="actions">
                      <button
                        class="button button-primary"
                        v-on:click="openEditor(index)"
                      >
                        <svg
                          x="0px"
                          y="0px"
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            />
                          </g>
                        </svg>
                      </button>
                      &nbsp;
                      <button
                        class="button button-error"
                        v-on:click="deleteSecaoRodape(index)"
                      >
                        <svg
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            />
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Edit from './Edit';
import { get, post, put, del } from '@/helpers/apiRequest';
const url = '/secoes-rodape';

const SECAO_MODEL = {
  descricao: '',
  ordem: '',
};

export default {
  components: {
    Edit,
  },
  name: 'secoesRodape',
  data() {
    return {
      loading: false,
      error: null,
      editorFunction: () => {},
      secoesRodape: [],
      currentSecaoRodape: { ...SECAO_MODEL },
    };
  },
  methods: {
    openEditor(index) {
      if (index >= 0) {
        this.currentSecaoRodape = { ...this.secoesRodape[index] };
        this.editorFunction = this.updateSecaoRodape;
      } else {
        this.currentSecaoRodape = { ...SECAO_MODEL };
        this.editorFunction = this.createSecaoRodape;
      }

      this.$modal.show('editSecaoRodape');
    },

    closeEditor() {
      this.secaoRodape = { ...SECAO_MODEL };
      this.$modal.hide('editSecaoRodape');
    },

    onEditSuccess() {
      this.$modal.hide('editSecaoRodape');
      this.fetchSecoesRodape();
    },

    edit(apiMethod, onSuccess, onError, onFinish) {
      this.loading = true;
      return apiMethod()
        .then((json) => {
          this.error = null;
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess();
          }
        })
        .catch((err) => {
          this.error = err;
          if (onError && typeof onError === 'function') {
            onError();
          }
        })
        .finally(() => {
          this.loading = false;
          if (onFinish && typeof onFinish === 'function') {
            onFinish();
          }
        });
    },
    createSecaoRodape(callback) {
      const apiMethod = post.bind(this, url, this.currentSecaoRodape);
      return this.edit(apiMethod, callback);
    },
    updateSecaoRodape(callback) {
      const apiMethod = put.bind(
        this,
        `${url}/${this.currentSecaoRodape._id}`,
        this.currentSecaoRodape
      );
      return this.edit(apiMethod, callback);
    },
    deleteSecaoRodape(index) {
      this.$swal({
        title: 'Confirma remover?',
        showCancelButton: true,
        type: 'error',
        confirmButtonColor: '#d82727',
      }).then(() => {
        const { _id } = this.secoesRodape[index];
        const apiMethod = del.bind(this, `${url}/${_id}`);
        this.edit(apiMethod, this.onEditSuccess);
      });
    },
    fetchSecoesRodape(callback) {
      this.loading = true;
      get(url)
        .then((json) => {
          this.secoesRodape = json;
          this.error = null;
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  beforeMount() {
    this.fetchSecoesRodape();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/SecoesRodape/SecoesRodape.vue